// import external dependencies
import 'jquery';
import 'vide';
import 'magnific-popup'

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import './custom/menu';
import './custom/learn_more';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$('#video-target').vide();
console.log('play video');

$('.video-link').magnificPopup({type:'iframe'});



// WEBPACK FOOTER //
// ./scripts/main.js